export default __webpack_public_path__ + "static/media/Idris.908e5e45.jpg";